import React, { useContext, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { ModalContext } from 'App';
import PinInput from 'modules/common/components/PinInput';
import * as actions from '../../../actions';
import * as c from '../../../constants';

function AuthenticatorConfirm({ goBack, history,
  isLoading,
  mfaLogin,
  profile,
  token,
  selectedMfa,
  updateMfaType
}) {

  const [formData, setFormData] = useState({
    email: profile.email
  });

  const setModal = useContext(ModalContext);

  const handleGoBack = (e) => {
    e.preventDefault();
    goBack(0);
  };

  const handleOnchangePin = otp => {
    setFormData({
      ...formData,
      otp
    });
  };

  const handleOnSubmit = (e) => {
    e.preventDefault();
    const args = {
      secret: formData.otp,
      mfa_type: 'google_authenticator',
      token,
    };
    mfaLogin(args, () => {
      if (selectedMfa === 1) {
        const mfaPayload = {
          token,
          preferred_mfa: 'google_authenticator',
          email: profile.email
        }
        updateMfaType(mfaPayload, () => {
        });
      }
      setModal({ isOpen: false });
      history.push('/');
    });
  };

  return (
    <>
      <form className="mfa-modal" onSubmit={handleOnSubmit}>
        <div className="form-header p-3">
          <span
            className="text-color text-center"
          >
            Multi-Factor Authentication is enabled. Please input the code shown in your authenticator app.
          </span>
        </div>
        <div className="col-12">
          <PinInput onChange={handleOnchangePin} />
        </div>
        <div className="col-12">
          <button
            type="submit"
            className="btn btn-primary mt-4 btn-block cms-bg-color-primary"
            disabled={isLoading || _.isEmpty(formData.otp)}
          >
            {isLoading && <i className="fa fa-spin fa-spinner" />}{" "}
            Submit
          </button>
        </div>
        <div className="text-center mt-2">
          <button
            type="button"
            onClick={handleGoBack}
            className="btn btn-change cms-text-primary"
          >
            <span className="font-weight-bold">
              Change Authentication Method
            </span>
          </button>
        </div>
      </form>
    </>
  );
}

AuthenticatorConfirm.defaultProps = {
  profile: {},
  selectedMfa: 0,
};


AuthenticatorConfirm.propTypes = {
  goBack: PropTypes.instanceOf(Function).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  isLoading: PropTypes.bool.isRequired,
  mfaLogin: PropTypes.instanceOf(Function).isRequired,
  profile: PropTypes.instanceOf(Object),
  token: PropTypes.string.isRequired,
  selectedMfa: PropTypes.number,
  updateMfaType: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  isLoading: _.get(api, "loading", []).indexOf(c.MFA_LOGIN) > -1,
  token: sessionStorage.getItem('temporaryToken') || '',
});


const enhance = _.flowRight([
  withRouter,
  connect(
    mapStateToProps,
    {
      ...actions,
    },
  ),
]);

export default enhance(AuthenticatorConfirm);